<template>
  <div>
    <div v-if="Object.keys(morningEveningProducts).length">
      <!-- title -->
      <single-report-header :title="report.getTitle()" :date="date" />

      <!-- iterate morning entries -->
      <v-row
        v-for="(
          morningEveningProduct, morningEveningProductIndex
        ) in morningEveningProducts"
        :key="morningEveningProductIndex"
        class="content-5 page-break-after"
      >
        <v-col class="col-12">
          <single-report-group-by-header
            :title="morningEveningProduct[0].getProductTranslation()"
            :right-title="
              $t('singleReport.totalPeople') +
              ': ' +
              lodash.sumBy(morningEveningProduct, 'peopleCount')
            "
          />

          <!-- column titles -->
          <v-row class="font-weight-black">
            <!-- people count -->
            <v-col class="col-1">
              {{ $t('myBookings.persons') }}
            </v-col>

            <!-- product definition -->
            <v-col class="col-2">
              {{ $t('singleReport.details') }}
            </v-col>

            <!-- user name -->
            <v-col class="col-2">
              {{ $t('shopBackendBookingOverview.customer') }}
            </v-col>

            <!-- mail -->
            <v-col class="col-3">
              {{ $t('general.email') }}
            </v-col>

            <!-- phone -->
            <v-col class="col-1">
              {{ $t('singleReport.tel') }}
            </v-col>

            <!-- note -->
            <v-col class="col-3">
              {{ $t('extraRides.comment') }}
            </v-col>
          </v-row>

          <!-- iterate entries of the product -->
          <v-row
            v-for="(bookingEntries, bookingEntriesIndex) in groupedByBookingId(
              morningEveningProduct
            )"
            :key="bookingEntriesIndex"
            class="border-top avoid-inside-break"
            :variable="(buyer = bookingEntries[0].getBooking().getBuyer())"
          >
            <!-- people count -->
            <v-col class="col-1 py-1">
              {{ lodash.sumBy(bookingEntries, 'peopleCount') }}
            </v-col>

            <!-- product definition -->
            <v-col class="col-2 py-1">
              <div
                v-for="(
                  prodDefs, prodDefKey, prodDefIndex
                ) in bookingEntriesByProductDefinition(bookingEntries)"
                :key="prodDefIndex"
              >
                {{ lodash.sumBy(prodDefs, 'peopleCount') }}x
                {{ prodDefs[0].getProductDefinitionTranslation() }}
              </div>
              <!-- {{bookingEntries[0].getProductDefinitionTranslation()}} -->
            </v-col>

            <!-- user name -->
            <v-col class="col-2 py-1">
              <p v-if="buyer.getCompany()" class="my-0">
                {{ buyer.getCompany() }}
              </p>
              {{ buyer.getFullName() }}
            </v-col>

            <!-- mail -->
            <v-col class="col-3 py-1">
              {{ buyer.getMail() }}
            </v-col>

            <!-- phone -->
            <v-col class="col-1 py-1">
              {{ buyer.getPhone() }}
            </v-col>

            <!-- iterate notes -->
            <v-col class="col-3 py-1">
              {{ bookingEntries[0].getBooking().getNote() }}
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </div>

    <!-- no booking entries -->
    <div v-else>
      <v-row>
        <v-col class="col-12 content-2">
          <span class="fal fa-folder-open mr-2" />
          {{ $t('singleReport.noContent') }}
        </v-col>
      </v-row>
    </div>
  </div>
</template>

<script>
import ReportMixin from '../ReportMixin'
import SingleReportHeader from '../SingleReportHeader'
import _ from 'lodash'
import SingleReportGroupByHeader from '../SingleReportGroupByHeader'

export default {
  name: 'ReportNiesenMorning',
  components: { SingleReportGroupByHeader, SingleReportHeader },
  mixins: [ReportMixin],

  data() {
    return {
      lodash: _,
    }
  },

  computed: {
    morningEveningProducts() {
      let bookingEntries = this.bookingEntryFilterable.getBookingEntries(true)
      if (bookingEntries.length) {
        let productFilter = (bookingEntry) => {
          // events
          if (bookingEntry.event) {
            let startTimeString = bookingEntry.event.startTime
            let startTime = startTimeString
              ? startTimeString.substring(0, 2)
              : 0

            // does time match with morning or evening?
            if (this.report.getSlug() === 'morning') {
              if (startTime <= 12) return true
              return false
            } else if (this.report.getSlug() === 'evening') {
              if (startTime > 12) return true
              return false
            }
            return true
          }

          // filter for weekendBrunch (10007) and breakfast (10008)
          if (this.report.getSlug() === 'morning')
            return (
              bookingEntry.productId === 10007 ||
              bookingEntry.productId === 10008
            )
          else if (this.report.getSlug() === 'evening') {
            return (
              bookingEntry.productId === 10004 || // niesenBuffet
              bookingEntry.productId === 10005 || // schwyzerisch
              bookingEntry.productId === 10006 || // fondue
              bookingEntry.productId === 10009
            ) // vollmond
          }
        }

        // filter booking entries by fitting products and events
        let filteredEntries = bookingEntries.filter(productFilter)
        // sort by booking id. closes https://pricenow.atlassian.net/browse/T1-701
        filteredEntries.sort((a, b) => a.booking.id - b.booking.id)
        // group by product
        return (filteredEntries = _.groupBy(
          filteredEntries,
          (filteredEntries) => filteredEntries.productId
        ))
      }
      return []
    },
  },

  mounted() {
    // via mixin
    this.loadBookingEntriesFilterable()
  },

  methods: {
    groupedByBookingId(morningProduct) {
      return _.groupBy(morningProduct, (entry) => entry.getBooking().getId())
    },
    bookingEntriesByProductDefinition(bookingEntries) {
      return _.groupBy(bookingEntries, (entry) => entry.productDefinitionId)
    },
  },
}
</script>
